(function(){
  function formatRatingSnippet() {
    const ratingSnippets = document.querySelectorAll('.ruk_rating_snippet');

    ratingSnippets.forEach(snippet => {
      const ratingCounts = snippet.querySelectorAll('.ruk-rating-snippet-count');

      if (ratingCounts.length >= 2) {
        // Replace decimal point with comma in the first count
        const firstCount = ratingCounts[0];
        firstCount.textContent = firstCount.textContent.replace('.', ',');

        // Add brackets around the second count (review count) only if not already present
        const lastCount = ratingCounts[1];
        const trimmedText = lastCount.textContent.trim();
        if (!trimmedText.startsWith('(') && !trimmedText.endsWith(')')) {
          lastCount.textContent = `(${trimmedText})`;
        }
      }
    });
  }
  document.addEventListener('DOMContentLoaded', () => {
    let productsList = document.querySelectorAll('.bundle-set__items .sort-items__option:not([disabled])'),
        sizeVariantsWrappers = document.querySelectorAll('.size__variants--wrapper .variant__picker'),
        addToCartBtns = document.querySelectorAll('[data-action="add-bundle-cart"');

    // handle changing product color
    productsList.forEach(product => {
      product.addEventListener('click', () => {
        let img = document.querySelector(`#product-image-${product.dataset.index}`),
            productUrl = document.querySelector(`#product-url-${product.dataset.index}`),
            title = document.querySelector(`#product-title-${product.dataset.index}`),
            colorName = document.querySelector(`#color-name-${product.dataset.index}`),
            colorValue = document.querySelector(`#color-value-${product.dataset.index}`),
            selectedProduct = document.querySelector(`.sort-items__option[data-index="${product.dataset.index}"].is-active`),
            variantContainer = document.querySelector(`.variant__picker.variant__picker--${product.dataset.index} .variant__wrapper`),
            productJsonData = JSON.parse(product.querySelector(`#product-json-${product.dataset.productId}`).textContent),
            preselectedSize = document.querySelector(`.variant__picker.variant__picker--${product.dataset.index} .variant__item.is-active`),
            sizeGuideModalOpen = document.querySelector(`#size-guide-modal-${product.dataset.index}`),
            parentWrapper = document.querySelector(`.bundle-set_item--${product.dataset.index}`),
            starsContainer = document.querySelector(`.bundle-set_item--${product.dataset.index} .bundle-set_item--content .reviews__container a`),
            starsUpdated = document.querySelector(`.product__reviews-${product.dataset.productId} .reviews__container a`);
            sizePopupBtn = document.querySelector(`.product-popup-modal__opener-${product.dataset.index}`);
        // handle no image
        // unselect old product
        if(selectedProduct) selectedProduct.classList.remove('is-active');
        // update product content
        if(img && title && colorName && colorValue && parentWrapper){
          img.src = product.dataset.image;
          title.innerHTML = product.dataset.title;
          title.href = product.dataset.url;
          colorName.innerHTML = product.dataset.colorName;
          colorValue.style.background = product.dataset.color;
          if(product.dataset.secondColor && product.dataset.secondColor != ''){
            colorValue.style.background = `linear-gradient(110deg, ${product.dataset.color} 50%, ${product.dataset.secondColor} 50%)`;
          }
          parentWrapper.setAttribute('data-product-id', product.dataset.variantId);
          parentWrapper.setAttribute('data-product-handle', product.dataset.productHandle);
        }
        // update reviews stars
        if(starsContainer && starsUpdated) {
          starsContainer.innerHTML = starsUpdated.innerHTML.replace(/Review/g, ' ');
          setTimeout(() => formatRatingSnippet(), 0);
        }
        // update product url
        if(productUrl) productUrl.href = product.dataset.url;
        // update size guide modal id
        if(sizeGuideModalOpen) sizeGuideModalOpen.setAttribute('data-modal', `#PopupSizeModal-size-chart-block-${product.dataset.productId}`);
        // select active product
        if(!product.classList.contains('is-active')) product.classList.add('is-active');
        // update product sizes
        if(productJsonData['variants'] && variantContainer){
          let sizesHtmlTemplate = '';
          productJsonData['variants'].forEach(variant => {
            let variantItemClasses = 'variant__item variant_label variant_label--circle';

            if(!variant.available){
              variantItemClasses += ' soldout';
            }
            if(preselectedSize && variant['option1'].trim() == preselectedSize.dataset.value.trim() && (variant.available)){
              let parentWrapper = document.querySelector(`.bundle-set_item--${product.dataset.index}`);
              if(parentWrapper) parentWrapper.setAttribute('data-product-id', variant.id);
              variantItemClasses += ' is-active';
            }
            sizesHtmlTemplate += `<div class="${variantItemClasses}" data-variant-id="${variant.id}" data-index="${product.dataset.index}" data-value="${variant['option1']}">\
              <span>${variant['option1']}</span>\
            </div>`
          })
          variantContainer.innerHTML = sizesHtmlTemplate;
          // handle soldout selected variant
          if(!sizesHtmlTemplate.includes('is-active')){
            let addActiveElement = variantContainer.querySelector('.variant__item:not(.soldout');
            if(addActiveElement){
              addActiveElement.classList.add('is-active');
              let parentWrapper = document.querySelector(`.bundle-set_item--${addActiveElement.dataset.index}`);
              if(parentWrapper) parentWrapper.setAttribute('data-product-id', addActiveElement.dataset.variantId);
            }
          }
        }
        // close dropdown
        let dropdown = product.closest('.sort-items__button--popup');
        if(dropdown) dropdown.removeAttribute('open');
        if(sizePopupBtn) {
          const modalId = `#PopupModal-${product.dataset.productId}`;
          sizePopupBtn.setAttribute('data-modal', modalId);
          const modal = document.querySelector(modalId);
          if (modal) {
            sizePopupBtn.classList.remove('hidden');
          } else {
            sizePopupBtn.classList.add('hidden');
          }
        }
      });
    });
    // handle selecting the size
    sizeVariantsWrappers.forEach(sizeWrapper => {
      sizeWrapper.addEventListener('click', (e) => {
        if(e.target.classList.contains('variant__item') && !e.target.classList.contains('soldout')){
          let setSizesWrapper = document.querySelectorAll(`.variant__picker--${e.target.dataset.index} .variant__item.is-active`);
          let parentWrapper = document.querySelector(`.bundle-set_item--${e.target.dataset.index}`);
          let sizeText =  document.querySelector(`.variant__picker--${e.target.dataset.index} .selected__variant-size span.size`);
          setSizesWrapper.forEach(item => {
            item.classList.remove('is-active');
          });
          e.target.classList.add('is-active');
          if(sizeText) sizeText.innerHTML = e.target.dataset.value;
          if(parentWrapper) parentWrapper.setAttribute('data-product-id', e.target.dataset.variantId);
        }
      });
    })
    // handle add to cart bundle
    if(addToCartBtns){
      addToCartBtns.forEach(btn =>{
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          let mainProductId = document.querySelector('[name=id]');
          if(!mainProductId) return;

          let selectedItems = document.querySelectorAll('.bundle-set__items .bundle-set_item'),
              cartModal = document.querySelector('cart-drawer'),
              setId =  document.querySelector('.bundle-set__items').getAttribute('data-set-id'),
              formItems = [],
              bundleItemsIds = [],
              bundleItemsHandles = [];

          if(cartModal)
            cartModal.setActiveElement(document.activeElement);


          let mainProductItem = {
            'id': parseInt(mainProductId.value),
            'quantity': 1,
            'properties': {
              "_setId": setId
            }
          };
          selectedItems.forEach(function(ele) {
            bundleItemsIds.push(parseInt(ele.dataset.productId));
            bundleItemsHandles.push(ele.dataset.productHandle);
          });
          if(mainProductId.getAttribute('data-name')) mainProductItem['properties']['_bundle_set_title'] = mainProductId.getAttribute('data-name');
          mainProductItem['properties']['_includeItem'] = bundleItemsIds.join(',');
          mainProductItem['properties']['_includeItemHandles'] = bundleItemsHandles.join(',');
          formItems.unshift(mainProductItem)
          // add cart sections
          let body = JSON.stringify({
            items: formItems,
            sections: "drawer-cart-items,drawer-cart-footer,cart-icon-bubble",
            sections_url: window.location.pathname
          });

          fetch(`${routes.cart_add_url}`, {...fetchConfig(),...{ body }}).then((response) => {
            if(response.status != 200) return response;
            return response.json();
          })
          .then((response) => {
              if(cartModal)
                cartModal.renderContents(response, true);
          })
          .catch((e) => {
              console.error(e);
          })
        });
      })
    }
  });
  window.addEventListener('load', () => {
    formatRatingSnippet();
  });
})();